export default {
    id: 8,
    rank: 8,
    name: "Botemania",
    bonoEuros: 200,
    bonoCasino: 200,
    reviewUrl: "/bono_botemania",
    bonoUrl: "https://www.botemania.es/juegos/casino-online",
    bonoCasinoUrl: "https://www.botemania.es/juegos/casino-online",
    rating: 4.5,
    metaTitle: "Botemania: Opinión y Análisis 2020 | Obtén 15€ o 20€ Gratis",
    metaDescription: "Análisis y opinión franca de Botemania. La guía más completa para que todo apostante pueda sacar el máximo partido a su dinero y tiempo.",
    imageUrl: "bm_banner.png",
    intoduction: `<p class="opinion-p-space">
    Botemanía, es una página de juegos, casino y bingo online con base en Barcelona y en Londres. En España opera desde
    el 2008 bajo el grupo Gamesys Spain PLC, una empresa de base británica con una trayectoria solida en el sector
    juego. La empresa viene regulada en España por la Dirección de Ordenación del Juego y ha obtenido las licencias
    pertinentes para el desarrollo de la actividad<br />
    <br />
    Se trata de una de las webs con mayor aceptación y que es del gusto del jugador español. Ofrece variedad de juegos
    de slots, casino, bingo y ruleta. Cuentan con un amplio catalogo con mas de 200 juegos online, además de premios
    cada dos segundos.<br />
    <br />
    Si bien Botemania no ofrece apuesta deportiva, es el web número uno de bingo en España, y además de reparte cada día
    grandísimos botes.<br />
    <br />
    Son bastante activos en sus canales sociales de YouTube, Facebook y Twitter.<br />
    <br />
    <strong>#PROTip:</strong> Recomiendo echarle un ojo especialmente al perfil de Facebook, que es el más dinámico y en donde
    periódicamente se organizan sorteos exclusivos para sus seguidores.<br />
    <br />
    <div class="opiniones-img">
        <img src="assets/images/bm_ancherwoman.jpg" />
    </div>
    Botemanía tiene versión desktop, móvil y app. A la app le han hecho mejoras y ahora carga el doble de rápido que en
    su primera versión.<br />
    <br />
    En cuanto a promociones, existe un bono de bienvenida con el cual los usuarios nuevos tienen la posibilidad de
    desbloquear el 200% sobre el primer ingreso hasta un máximo de 200€.<br />
    <br />
    Si quieres conocer a detalle cómo sacar partido al bono u otras promociones te invito a seguir conmigo para un
    contraste detallado de lo bueno y lo malo de Botemanía.<br />
    <br />
    Si por el contrario ya has leído suficiente y te has animado a probar Botemania. <a href="https://www.botemania.es/register" target="#blank">Obtén tu bono de 200€ con tu primer
        deposito.</a>    
</p>`,
    prosandCons: [
        {
            type: "pro",
            comment: "El mejor bingo online"
        }, {
            type: "pro",
            comment: "Cartones de bingo desde 1 céntimo"
        }, {
            type: "pro",
            comment: "Gran variedad de juegos de slots y casino"
        }, {
            type: "con",
            comment: "No ofrece apuesta deportiva"
        },
        {
            type: "con",
            comment: "Bono de bienvenida difícil de canjear"
        }
    ],
    deposit: ["paypal", "visa", "mastercard", "paysafe"],
    withdraw: ["paypal", "visa", "mastercard", "paysafe", "banktransfer"],
    contact: {
        phoneNumber: "900 81 85 86",
        email: "ayuda@botemania.es",
        chat: true
    },
    opinion: `<div id="main-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Variedad
</div>
<div class="opinion-card-subtitle">
    Bingo
</div>
<p class="opinion-p-space">
    Botemania es el referente de Bingo virtual en España. Los usuarios tienen a su disposición juegos de 75 o 90 bolas,
    cartones desde 1 céntimo y botes impresionantes que en ocasiones superan los 85.000€. A su vez, existen distintas
    modalidades de bingo como el Bingote, Rapibingo, Bono Bingo, Super Bingo o el Tiki Bingo.<br />
    <br />
    Los bingos de 75 bolas tienen premios por cartón completo y botes. Mientras que los bingos de 90 bolas tienen
    premios de 1 linea, 2 lineas, cartón completo y botes progresivos. Sea cual sea la modalidad que elijas, te
    encantará el bingo online porque es un tipo de juego en el que por muy poco dinero puedes conseguir premios
    sustanciosos además de estar un buen rato entretenido.<br />
    <br />
    Algunas de las modalidades mas populares entre los jugadores son:<br />
    <br />
    • Super Bingo 6: bingo de 90 bolas con bote progresivo y posibilidad de cartones gratuitos. Hay una partida cada 5
    minutos y el precio oscila entre 1 céntimo y 25 céntimos el cartón.<br />
    • Bingote: bingo de 75 bolas y bote progresivo. Se permite jugar de forma automática y el precio del cartón es de 10
    céntimos. Una vez mas tendrás partidas cada 5 minutos.<br />
    • Bingo 80: bingo de 80 bolas. Cartones a un precio de 1 céntimo a 1€. El premio se canta con 1 linea, 2 lineas y
    cartón lleno o bingo. La sala esta disponible de 18 a 21 horas.<br />
    <br />
    Un plus del Bingo virtual en Botemania, es que cada sala cuenta con un chat en vivo en el que puedes interactuar con
    otros usuarios y el nivel de participación suele alto. Aquí podrás compartir tu experiencia con otros jugadores y
    hacer cualquier pregunta al moderador.<br />
    <br />
    A través del chat también se ofrecen mini-juegos o partidas gratuitas de Bingo cada 30 minutos. Al momento de
    escribir esta opinión, se celebraban cada día de 15:00 a 19:00 horas en la sala Siesta Bingo y los miércoles de
    12:00 horas a 21:00 horas en la sala Siesta Bingo Plus.<br />
    <br />
    Para participar en las partidas de bingo gratuitas solo debes registrarte correctamente y hacer el ingreso mínimo de
    10€. Sinceramente, merece la pena desbloquear todos estos juegos gratuitos, ya que por un ingreso muy bajo tienes la
    posibilidad de participar siempre y sacar una considerable cantidad de dinero.
</p>

<div class="opinion-card-subtitle">
    Tragamonedas
</div>
<p class="opinion-p-space">
    Botemania.es ofrece una importante cantidad y calidad de slots donde podrás disfrutar de más de 200 títulos. Entre
    ellos los más populares como Los Secretos del Fénix, el Duble Buble o La Isla Tiki. También encontramos los clásicos
    como Rainbow Riches, además de otros juegos exclusivos de Botemania.<br />
    <br />
    El catálogo cuenta con variedad de títulos clásicos y otros menos conocidos, pero de gran calidad como “Family Guy”,
    “El Padrino”, “Agatha Christie’s Mystery Wilds” y muchos más. Este tipo de juego es bastante demandado en el sector
    apuestas, principalmente por toda la experiencia de las interfaces y sonidos que te llevan a un casino real sin
    salir de casa.<br />
    <br />
    Algo que nos ha llamado la atención, es que Botemania tiene tragamonedas gratuitas, para algunas no es necesario
    hacer un ingreso. Para otras será necesario realizar un primer ingreso mínimo de 10€. Pero lo cierto es que por una
    pequeña cantidad de dinero merece la pena desbloquear el acceso a los juegos gratuitos para siempre.<br />
    <br />    
    <strong>#PROTip:</strong> Podrás encontrar los slots gratuitos pinchando en juegos y luego en juegos gratis. Es una manera
    excepcional de probar la web y la suerte.<br />
    <br />
    También es posible probar muchos de los juegos disponibles en su versión demo para ver como funcionan antes de
    jugarnos dinero real.
</p>

<div class="opinion-card-subtitle">
    Casino
</div>

<p class="opinion-p-space">
    Como he mencionado antes, Botemania Casino es una de las subsecciones de la web que abarca todo tipo de juegos de
    mesa asociados al casino, tal y como la ruleta, blackjack, classic keno y otros juegos de cartas como el Mayor
    Menor.<br />
    <br />
    El catalogo de casino es de gran tamaño. Cuentan con unos 180 juegos distintos, y la selección de juegos es solida y
    de gran calidad.<br />
    <br />
    Una de las secciones más emocionantes en Botemania, es la de la ruleta en vivo en donde podrás disfrutar de la
    emoción de jugar mano a mano contra jugadores reales desde la comodidad de tu casa o desde donde quieras si te
    descargas la app. El entorno de juego está muy conseguido. Hay decenas de juegos y puedes jugar 24/7 por una apuesta
    mínima de 1€.<br />
    <br />
    En otros juegos del casino podrás conseguir tiradas desde solo 1 céntimo y botes elevados que en el algún momento
    han llegado a superar los 245.000€.
</p>
<!-- ----------------------------------------------------------------------------------------------------------------------------------->
<div id="bonos-prom-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Bonos y Promociones
</div>
<div class="opinion-card-subtitle">
    Bono de Bienvenida: 200% del primer deposito hasta 200€
</div>

<p class="opinion-p-space">
    En Botemania tenéis un bono de bienvenida que está disponible para todos los usuarios durante su primer deposito de
    dinero y es opcional. En mi opinión, es uno de los bonos casino mas rentables de España.<br />
    <br />
    Se trata de un <a href="https://www.botemania.es/register" target="#blank">bono del 200% de tu primer depósito, con un máximo de 200€ de bono</a> (100€ de ingreso). Es el bono muy
    alto y el que más tracción tiene a la hora de captar nuevos jugadores.<br />
    <br />
    Ten en cuenta que en otros casinos virtuales para conseguir un bono similar a este, tendrías que jugar su valor de
    20 a 30 veces. No es el caso de Botemania que ofrece una promoción bastante razonable. Explicare como obtenerlo a
    continuación.<br />
    <br />
    Como cualquier bono de bienvenida, está sujeto a ciertas condiciones:<br />
    <br />
    • Antes de poder solicitar un reintegro de dinero, se pide a los usuarios que apuesten 4 veces la cantidad del bono
    recibida. Por ejemplo, si recibes un bono de 50€, tendrás que apostar 200€ antes de solicitar un reintegro. Ahora
    bien, según qué tipo de juego contribuiremos en distintas proporciones a la liberación del bono:<br />
    <br />
<div class="info-grid-2">
    <div class="info-grid-header">Juego </div>
    <div class="info-grid-header">Contribución a la liberación del bono</div>
    <div>Bingo (excepto Rapibingo)</div>
    <div>100%</div>
    <div>Rapibingo</div>
    <div>25%</div>
    <div>Slots</div>
    <div>10%</div>
    <div>Instantáneos, Casino y Casino en Vivo</div>
    <div>5%</div>
    <div>Ruleta</div>
    <div>2.5%</div>
    <div>Blackjack, Poker, “Calles de Oro” en Ruleta y resto de juegos</div>
    <div>0% (no contribuyen)</div>
</div>
<br />
<br />
Como ves, hace falta jugar al menos 4 veces más dinero del que hemos recibido para desbloquear el bono.<br />
<br />
Ahora te estarás preguntando si realmente merece o no la pena el bono. Personalmente pienso que según que tipo de
jugador seas, merecerá más o menos. Si eres de los que le gusta echarle horas al juego (como a mi), si merece la pena.<br />
<br />
También hay que decir que en Botemania los juegos disponibles actualmente tienen un margen de ganancias de entre el 75%
y 90%. Es decir, las probabilidades de ganar son altas.<br />
<br />
<strong>#PROTip:</strong> Además, tened en cuenta que los cartones de Bingo son muy económicos y podéis comprar muchos para aumentar las
probabilidades de quedaros con el acumulado.<br />
<br />
<strong>#PROTip:</strong> La opción más económica para aprovechar el bono seria la siguiente. Ingresar 10€ al momento de crear la cuenta
y recibi rás 20€ de bono de bienvenida, de manera que en tu cuenta dispondrás de un total de 30€ para usar en la web. Y
antes de retirar las ganancias deberás jugar 80€ adicionales en cartones de bingo que contribuyen en un 100% para
liberar el bono finalmente.<br />
<br />
Puedes ver en todo momento el importe restante para liberar el bono de bienvenida desde la sección de Reintegro en tu
perfil de jugador.<br />
<br />
</p>
<div class="opinion-card-subtitle">
    Bono Gratis Por Registro
</div>

<p class="opinion-p-space">
    Se trata de códigos promocionales puntuales que aparecen en anuncios publicitarios de prensa, radio o televisión.
    Los códigos promocionales suelen ser de 10€ gratis, y siempre están sujetos al registro de un nuevo usuario.
    Adicionalmente, en ocasiones puede estar sujeto a un primer deposito.<br />
    <br />
    <strong>#PROTip:</strong> Si no tienes prisa recomiendo estar atentos a sus redes sociales, principalmente al perfil de Facebook de
    Botemania. No en vano, muchas de las promociones y sorteos se anuncian por estos medios. Suelen ser promos pequeñas de
    hasta 10€.<br />
    <br />
    Si por el contrario quieres empezar a jugar hoy <a href="https://www.botemania.es/register" target="#blank">obtén tu bono de 200% hasta 200€</a>
</p>

<div class="opinion-card-subtitle">
    Invita a Un Amigo
</div>

<p class="opinion-p-space">
    Puedes recibir 20€ por cada amigo que invites, siempre y cuando se cumplan las siguientes condiciones:<br />
    <br />
    • El amigo invitado debe registrarse introduciendo el nombre del amigo en la casilla correspondiente durante el
    registro de su nueva cuenta.<br />
    • El amigo invitado debe ingresar un mínimo de 10€.<br />
    • El amigo invitado debe realizar apuestas en juegos de Bingo por un valor mínimo de 40€, 160€ en Rapabingo, 400€ en
    Slots, 800€ en casino o 1.600€ en ruleta.
</p>

<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="depositos-retiros-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Depósitos, Retiros y Métodos de Pago
</div>

<div class="opinion-card-subtitle">
    Depositos
</div>

<p class="opinion-p-space">
    En Botemania podrás ingresar dinero a tu cuenta de jugador de las siguientes formas:<br />
    <br />
    <div class="info-grid-3">
        <div class="info-grid-header">Método de Pago </div>
        <div class="info-grid-header">Ingreso Mínimo</div>
        <div class="info-grid-header">Ingreso Máximo</div>
        <div>Tarjetas Bancarias VISA y MASTERCARD</div>
        <div>10€</div>
        <div>10.000€</div>
        <div>PayPal</div>
        <div>10€</div>
        <div>8.000€</div>
        <div>PAYSAFECARD</div>
        <div>10€</div>
        <div>1.000€</div>
    </div>
    <br />
    <br />
    Con cada método de pago las transacciones son seguras e inmediatas.<br />
    <br />
    Paysafecard es una tarjeta prepaga que te permite ingresar y retirar dinero de forma segura.<br />
    <br />
    PayPal es una pasarela de pago virtual en la que puedes utilizar tu tarjeta de crédito o debito o tu cuenta
    bancaria.
</p>

<div class="opinion-card-subtitle">
    Retiradas
</div>

<p class="opinion-p-space">
    Para cobrar un reintegro debes clicar en ‘Mi cuenta’ en la esquina superior derecha y seleccionar la opción
    ‘Reintegro’.<br />
    <br />
    Los reintegros se cobran en el mismo método de pago que se utilizo para ingresar el dinero en primer lugar. Si por
    alguna razón tu método de pago no estuviese disponible a la hora de retirar las ganancias, la retirada se efectuará
    mediante transferencia bancaria a una cuenta cuyo titular sea el mismo que el de la cuenta de jugador de
    botemania.es<br />
    <br />
    <div class="info-grid-4">
        <div class="info-grid-header">Método de Pago </div>
        <div class="info-grid-header">Reintegro Mínimo</div>
        <div class="info-grid-header">Reintegro Máximo</div>
        <div class="info-grid-header">Plazos de Pago</div>
        <div>Tarjera de crédito o debito</div>
        <div>10€</div>
        <div>5.000€</div>
        <div>1-8 días hábiles</div>
        <div>Cuenta bancaria</div>
        <div>20€</div>
        <div>2.000€</div>
        <div>1-8 días hábiles</div>
        <div>PayPal</div>
        <div>10€</div>
        <div>8.000€</div>
        <div>24 horas</div>
        <div>Paysafecard</div>
        <div>20€</div>
        <div>2.000€</div>
        <div>24 horas</div>
    </div>
    <br />
    <br />
    En tu perfil de jugador podrás consultar en todo momento el estado de tu reintegro. Si el estado del reintegro es
    Pendiente, significa que aun no se ha enviado y estas a tiempo de cancelar y devolverlo a saldo.<br />
    <br />
    Cabe destacar que no hay comisiones por retirada. Pero hay que cumplir con los mínimos de reintegro correspondientes
    a cada método de pago. Por ejemplo, si tu saldo es menor a 10€ y quieres retirarlo por PayPal, deberás hacer un
    ingreso por el importe que te falte para llegar al mínimo reintegrable.
</p>
<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="seguridad-fiabilidad-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Seguridad y Fiabilidad
</div>
<p class="opinion-p-space">
    Botemania es un bingo y casino online totalmente fiable y seguro.<br />
    <br />
    Actualmente tiene licencia de apuestas en España por la Dirección de Ordenación del Juego. Esto asegura que están
    obligadas a adherirse a las estrictas normas del acuerdo. Por ejemplo, garantizar la transparencia en las apuestas,
    disponer de atención al cliente, protección al usuario, entre otras.<br />
    <br />
    De acuerdo con la Nueva Ley del Juego Online en España que regula el juego en internet. Todo usuario deberá
    confirmar sus datos personales: nombre y apellidos, fecha de nacimiento, nacionalidad y DNI/NIE. Si eres extranjero
    y juegas desde fuera de España, de acuerdo a la nueva legislación, no te será permitido acceder a Botemania.<br />
    <br />
    Toda la información personal enviada es encriptada a través de una 40-bit Secure Socket Layer Digital, lo que hace
    que los datos estén bien protegidos. Ésta es la misma metodología de seguridad utilizada por bancos.<br />
    <br />
    Así mismo, el personal de Botemania no puede conocer los números de las tarjetas del jugador ni las contraseñas del
    jugador puesto que están encriptados. Se utiliza además un servicio anti-fraude para asegurar la protección de los
    titulares de las tarjetas de crédito o débito.
</p>
<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="ui-ux-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Interfaz y Experiencia de Usuario
</div>
<p class="opinion-p-space">
    En web encontraras un interface muy intuitiva y fácil de navegar tanto en su versión desktop como móvil. El Portal
    de Botemania también esta disponible en app para móvil y tablet. ¡Ya no importa donde te encuentres! Si tienes tu
    dispositivo a mano y conexión a internet, podrás disfrutar de tus juegos favoritos.<br />
    <br />
    Al entrar a Botemania Casino sabrás exactamente a donde ir independientemente de lo que busques.<br />
    <br />
    Todo ocurre de forma veloz, los links y juegos se cargan rápidamente
</p>
<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="atencion-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Atención al cliente
</div>
<p class="opinion-p-space">
    El equipo de atención está disponible cada día durante los siguientes horarios:<br />
    <br />
    • Lunes a viernes: 10 a 24 horas<br />
    • Fines de semana y festivos: 12 a 24<br />
    <br />
    A Botemania se le puede contactar de las siguientes formas:<br />
    <br />
    • Teléfono gratuito: 900 81 85 86<br />
    • Correo electrónico a ayuda@botemania.es<br />
    • Chat: lo encontrareis en help.botemania.es en la esquina inferior derecha. No se trata de un chat 24/7 pero el
    horario de atención es amplio. En caso de contactar por el chat fuera del horario de atención al cliente, podremos
    dejar un mensaje y nos contestaran lo antes posible.
<div class="opiniones-img">
    <img src="assets/images/bt_contactform.png" />
</div>
En mi caso, he tenido que contactar a atención al cliente mediante el chat para gestionar un problema de registro. La
experiencia ha sido buena, se me ha contestado rápido durante un fin de semana y la solución ha sido eficaz.
</p>
<!----------------------------------------------------------------------------------------------------------------------------------------->
<div id="conclusion-section" class="title-text opinion-card-title opinion-title-space linkable-section">
    Conclusión
</div>
<p class="opinion-p-space">
    Botemania me ha gustado, es una web fiable y optimizada para que los apostadores tengan una experiencia de juego
    segura y divertida. El servicio al cliente es rápido y profesional.<br />
    <br />
    Es una web casino online de agrado del jugador español y que lleva años liderando el sector del bingo online. Los
    botes acumulados suman al menos 25.000€ por día, este hecho hace que la experiencia de jugar al bingo en esta
    plataforma sea apasionante.<br />
    <br />
    La pagina web es sencilla y funciona correctamente. Dispone de app móvil y todo en general carga con rapidez. Los
    gráficos y la ambientación sonora son de altísima calidad.<br />
    <br />
    Finalmente, pienso que el bono de bienvenida es difícil de desbloquear. Pues la mayoría de los juegos con excepción
    del Bingo, no contribuyen al 100% de cara a su liberación. Espero que ha futuro tengamos mejores bonos de
    bienvenida.
</p>`
}